import { cva } from "class-variance-authority";
import { clsx } from "clsx";
import { type PropsWithChildren } from "react";

const radioButtonLabelStyles = cva("", {
  variants: {
    variant: {
      kiosk: "line-clamp-1 text-ellipsis text-3xl text-kiosk-text-primary"
    }
  }
});

type BaseInputProps = PropsWithChildren & {
  onClick: () => void;
  label: string;
  checked: boolean;
  variant?: "kiosk";
};

export const RadioButton = ({
  label,
  onClick,
  checked,
  variant,
  children
}: BaseInputProps) => {
  return (
    <button className="w-full" onClick={onClick} type="button">
      <div className="flex items-center gap-3">
        <div className="relative size-6 rounded-full border-2 p-2">
          <div
            className={clsx(
              "absolute inset-0 m-auto size-4 rounded-full",
              checked && "bg-primary-main"
            )}
          />
        </div>

        <p className={radioButtonLabelStyles({ variant })}>{label}</p>

        {children}
      </div>
    </button>
  );
};
